import { AxiosError } from 'axios';
import { toast } from 'sonner';

export const handleApiError = (error: AxiosError) => {
    if (error.response) {
        // 서버 응답이 있는 경우
        const status = error.response.status;

        const message =
            (error.response.data as any)?.message ||
            '서버 오류가 발생했습니다.';

        switch (status) {
            case 400:
                toast.error('잘못된 요청입니다.');
                break;
            case 401:
                toast.error('인증이 필요합니다.');
                break;
            case 403:
                toast.error('접근 권한이 없습니다.');
                break;
            case 404:
                toast.error('요청한 자원을 찾을 수 없습니다.');
                break;
            case 500:
                toast.error('서버 내부 오류가 발생했습니다.');
                break;
            default:
                toast.error(message);
        }
    } else if (error.request) {
        // 요청은 보냈지만 응답을 받지 못한 경우
        toast.error('네트워크 오류가 발생했습니다.');
    } else {
        // 기타 오류
        toast.error('예상치 못한 오류가 발생했습니다.');
    }
};
